module.exports = __webpack_public_path__ + "media/application/images/landing-mockup-900-d4cd9985793549db15a4d32e13a1482d.png";